enum PERMISSIONS {
  /* -------- Ulams/Core -------- */

  CoreDashboardAccess = 'access dashboard', // TODO: #1025 unused in api

  /* -------- Ulams/Auth -------- */

  // USER
  UserManage = 'user_manage', // pozwala na cofnięcie `soft delete` lub na `twarde usunięcie` użytkownika

  UserCreate = 'user_create',
  UserRead = 'user_read',
  UserReadSelf = 'user_read_self', // user's own details
  UserReadCourseOwned = 'user_read_course-authored', // reading user details in courses for which you are the author
  UserUpdate = 'user_update',
  UserUpdateSelf = 'user_update_self', // edit own user
  UserDelete = 'user_delete',
  UserDeleteSelf = 'user_delete_self', // remove own user (TODO: #1026 hard or soft?)
  UserList = 'user_list',
  UserListCourseOwned = 'user_list_course-authored', // listing users in courses of which you are the author
  UserBulkNotificationList = 'bulk-notification_list', // listing bulk notifications
  UserBulkNotificationCreate = 'bulk-notification_create', // create (send) bulk notification

  // USER GROUP
  UserGroupCreate = 'user-group_create',
  UserGroupRead = 'user-group_read',
  UserGroupReadSelf = 'user-group_read_self', // details of the group you belong to (for tutors)
  UserGroupUpdate = 'user-group_update',
  UserGroupDelete = 'user-group_delete',
  UserGroupMemberAdd = 'user-group_member-add',
  UserGroupMemberRemove = 'user-group_member-remove',
  UserGroupList = 'user-group_list',
  UserGroupListSelf = 'user-group_list_self', // TODO: #1027 unused in api

  UserInterestUpdate = 'user-interest_update', // this is used to indicate which courses (or categories?) the user is interested in // TODO: #1029 unused in api
  UserInterestUpdateSelf = 'user-interest_update_self', // TODO: #1028 unused in api

  // these permissions are for arbitrary metadata assigned to a user
  UserSettingUpdate = 'user-setting_update',
  UserSettingUpdateSelf = 'user-setting_update_self',

  /* -------- Ulams/settings -------- */

  SettingsManage = 'settings_manage', // TODO: #1030 unused in api
  SettingsCreate = 'settings_create',
  SettingsRead = 'settings_read',
  SettingsUpdate = 'settings_update',
  SettingsDelete = 'settings_delete',
  SettingsList = 'settings_list',

  // is to edit Laravel settings that are loaded from /config files via the api in the Settings package
  SettingsConfigList = 'settings_config_list',
  SettingsConfigUpdate = 'settings_config_update',

  /* -------- Ulams/Cart -------- */

  ProductsList = 'products_list',
  ProductsManage = 'products_manage',
  ProductsListPurchasable = 'products_list_purchasable',
  ProductsBuy = 'products_buy',

  CartOrderList = 'cart_order_list',
  CartOrderListCourseOwned = 'cart_order_list_course-authored', // order listings for courses of which you are the author (for tutor)

  /* -------- Ulams/Files -------- */

  FileUpload = 'file_create',
  FileMove = 'move:files',
  FileDelete = 'file_delete',
  FileList = 'file_list',

  /* -------- Ulams/Courses -------- */

  CourseList = 'course_list',
  CourseCreate = 'course_create',
  CourseRead = 'course_read',
  CourseUpdate = 'course_update',
  CourseDelete = 'course_delete',
  CourseUpdateAuthored = 'course_update_authored',
  CourseDeleteAuthored = 'course_delete_authored',
  CourseReadAuthored = 'course_read_authored',

  /* -------- Ulams/H5P -------- */

  H5PList = 'h5p_list',
  H5PRead = 'h5p_read',
  H5PCreate = 'h5p_create',
  H5PDelete = 'h5p_delete',
  H5PUpdate = 'h5p_update',

  H5PAuthorList = 'h5p_author_list',
  H5PAuthorUpdate = 'h5p_author_update',

  H5PLibraryList = 'h5p_library_list',
  H5PLibraryRead = 'h5p_library_read',
  H5PLibraryCreate = 'h5p_library_create',
  H5PLibraryDelete = 'h5p_library_delete',
  H5PLibraryUpdate = 'h5p_library_update',
  H5PLibraryInstall = 'h5p_library_install',
  H5PLibraryUpload = 'h5p_library_upload',

  /* -------- Ulams/payments -------- */

  PaymentRead = 'payment_read',
  PaymentList = 'payment_list',

  /* -------- Ulams/Categories -------- */

  CategoryList = 'category_list',
  CategoryRead = 'category_read',
  CategoryCreate = 'category_create',
  CategoryUpdate = 'category_update',
  CategoryDelete = 'category_delete',

  /* -------- Ulams/pages -------- */

  PageList = 'page_list',
  PageRead = 'page_read',
  PageCreate = 'page_create',
  PageUpdate = 'page_update',
  PageDelete = 'page_delete',

  /* -------- Ulams/Scorm -------- */

  ScormList = 'scorm_list',
  ScormRead = 'scorm_read',
  ScormCreate = 'scorm_create',
  ScormUpdate = 'scorm_update',
  ScormDelete = 'scorm_delete',
  ScormGetTrack = 'scorm_track-read',
  ScormSetTrack = 'scorm_track-update',
  ScormListOwn = 'scorm_list-own',
  ScormReadOwn = 'scorm_read-own',
  ScormDeleteOwn = 'scorm_delete-own',

  /* -------- Ulams/Reports -------- */

  ReportList = 'report_list',

  /* -------- Ulams/Courses-Import-Export -------- */

  CourseExport = 'course-import-export_export',
  CourseImport = 'course-import-export_import',
  CourseExportAuthored = 'course-import-export_export_authored',
  COURSES_CLONE = 'course-import-export_clone',

  /* -------- Ulams/Auth: scoped API tokens -------- */

  TokenManage = 'token_manage',

  /* -------- Ulams/Permissions -------- */

  PermissionRoleManage = 'permission_role_manage',
  PermisionRoleList = 'permission_role_list',
  PermissionRoleCreate = 'permission_role_create',
  PermissionRoleDelete = 'permission_role_delete',
  PermissionRoleRead = 'permission_role_read',
  PermissionRoleUpdate = 'permission_role_update', // access to edit permissions

  /* -------- Ulams/Templates -------- */

  TemplateList = 'template_list',
  TemplateRead = 'template_read',
  TemplateCreate = 'template_create',
  TemplateDelete = 'template_delete',
  TemplateUpdate = 'template_update',

  /* -------- Ulams/Notifications -------- */

  NotificationListAll = 'dashboard-app_notification-list_access', // ability to read all notifications (including those not belonging to you)
  NotificationList = 'dashboard-app_notification-list_access_self',

  /* -------- Ulams/Questionnaire -------- */

  QuestionnaireList = 'questionnaire_list',
  QuestionnaireRead = 'questionnaire_read',
  QuestionnaireCreate = 'questionnaire_create',
  QuestionnaireDelete = 'questionnaire_delete',
  QuestionnaireUpdate = 'questionnaire_update',

  QuestionList = 'question_list',
  QuestionRead = 'question_read',
  QuestionCreate = 'question_create',
  QuestionDelete = 'question_delete',
  QuestionUpdate = 'question_update',

  /* -------- Ulams/Webinar -------- */

  WebinarList = 'webinar_list',
  WebinarCreate = 'webinar_create',
  WebinarUpdate = 'webinar_update',
  WebinarDelete = 'webinar_delete',
  WebinarRead = 'webinar_read',

  /* -------- Ulams/Consultations -------- */

  ConsultationList = 'consultation_list',
  ConsultationCreate = 'consultation_create',
  ConsultationUpdate = 'consultation_update',
  ConstulatationDelete = 'consultation_delete',
  ConsultationRead = 'consultation_read',

  /* -------- Ulams/Stationary-Events -------- */

  StationaryEventsList = 'stationary-event_list',
  StationaryEventsCreate = 'stationary-event_create',
  StationaryEventsUpdate = 'stationary-event_update',
  StationaryEventsRead = 'stationary-event_read',
  StationaryEventsDelete = 'stationary-event_delete',

  /* -------- Ulams/Vouchers -------- */

  VoucherList = 'coupon_list',
  VoucherCreate = 'coupon_create',
  VoucherRead = 'coupon_read',
  VoucherUpdate = 'coupon_update',
  VoucherDelete = 'coupon_delete',
  VoucherUse = 'coupon_use',

  /* -------- Ulams/translations -------- */
  TranslationList = 'translation_list',
  TranslationCreate = 'translation_create',
  TranslationRead = 'translation_read',
  TranslationUpdate = 'translation_update',
  TranslationDelete = 'translation_delete',

  /* -------- Ulams/Tasks -------- */

  TaskCreateOwn = 'task_create-own',
  TaskUpdateOwn = 'task_update-own',
  TaskDeleteOwn = 'task_delete-own',
  TaskListOwn = 'task_list-own',
  TaskFindOwn = 'task_find-own',
  TaskCreate = 'task_create',
  TaskUpdate = 'task_update',
  TaskDelete = 'task_delete',
  TaskList = 'task_list',
  TaskFind = 'task_find',
  TaskNoteCreate = 'task-note_create',
  TaskNoteUpdate = 'task-note_update',
  TaskNoteDelete = 'task-note_delete',

  CourseAccessCreateOwn = 'course-access_create-own',
  CourseAccessDeleteOwn = 'course-access_delete-own',
  CourseAccessListOwn = 'course-access_list-own',
  CourseAccessList = 'course-access_list',
  CourseAccessDelete = 'course-access_delete',
  CourseAccessApprove = 'course-access_approve',

  ConsultationAccessCreateOwn = 'consultation-access_create-own',
  ConsultationAccessListOwn = 'consultation-access_list-own',
  ConsultationAccessList = 'consultation-access_list',
  ConsultationAccessApprove = 'consultation-access_approve',
  ConsultationAccessDisapprove = 'consultation-access_disapprove',
  ConsultationAccessDeleteOwn = 'consultation-access_delete-own',
  ConsultationAccessUpdateOwn = 'consultation-access_update-own',

  /* -------- Ulams/Quiz -------- */
  QuizAttemptCreateOwn = 'quiz-attempt_create-own',
  QuizAttemptListOwn = 'quiz-attempt_list-own',
  QuizAttemptReadOwn = 'quiz-attempt_read-own',
  QuizAttemptList = 'quiz-attempt_list',
  QuizAttemptListSelf = 'quiz-attempt_list-self',
  QuizAttemptRead = 'quiz-attempt_read',
  QuizAttemptUpdate = 'quiz-attempt_update',

  /* -------- Ulams/Teacher -------- */

  /* -------- grades -------- */
  TeacherListGradeTerm = 'grade-term_list',
  TeacherListGradeScale = 'grade-scale_list',
  TeacherListOwnFinalGrade = 'final-grade_list-own',
  TeacherSaveOwnFinalGrade = 'final-grade_save-own',
  TeacherListFinalGrade = 'final-grade_list',
  TeacherSaveFinalGrade = 'final-grade_save',
  TeacherListOwnFinalGrades = 'final-grade_list-own',
  TeacherListExamResult = 'exam_list',
  TeacherListOwnExamResult = 'exam_list-own',
  TeacherListSelfExamResult = 'exam_list-self',
  TeacherSaveExamResult = 'exam_save',
  TeacherSaveOwnExamResult = 'exam_save-own',
  TeacherDeleteExamResult = 'exam_delete',
  TeacherDeleteOwnExamResult = 'exam_delete-own',

  /* -------- attendances -------- */
  TeacherListOwnAttendance = 'attendance_list-own',
  TeacherListAttendance = 'attendance_list-admin',
  TeacherSaveAttendance = 'attendance_save-admin',
  TeacherSaveTutorAttendance = 'attendance_save-own',

  /* -------- Ulams/pcg-integration -------- */
  PCGListAcademicYears = 'pcg-integration_academic-year_list',
  PCGListSemesters = 'pcg-integration_semester_list',
  PCGListSelfSemesters = 'pcg-integration_semester_list-self',
  PCGListSemesterSubjects = 'pcg-integration_semester-subject_list',
  PCGListSelfSemesterSubjects = 'pcg-integration_semester-subject_list-self',
  PCGReadSemesterSubjects = 'pcg-integration_semester-subject_read',
  PCGReadSelfSemesterSubjects = 'pcg-integration_semester-subject_read-self',
  PCGSchedulesDeleteOwn = 'pcg-integration_schedules_delete-own',
  PCGSchedulesDelete = 'pcg-integration_schedules_delete',

  /* -------- Ulams/sds-integration -------- */
  SDSExport = 'sds-integration_export',

  /* -------- Ulams/competency-challenges -------- */
  CompetencyChallengeScaleCreate = 'competency-challenge-scale_create',
  CompetencyChallengeScaleUpdate = 'competency-challenge-scale_update',
  CompetencyChallengeScaleDelete = 'competency-challenge-scale_delete',

  CreateCompetencyChallenges = 'competency-challenges_create',
  ReadCompetencyChallenges = 'competency-challenges_read',
  UpdateCompetencyChallenges = 'competency-challenges_update',
  DeleteCompetencyChallenges = 'competency-challenges_delete',
  ListCompetencyChallenges = 'competency-challenges_list',

  /* -------- Ulams/dictionary -------- */
  DictionaryList = 'dictionary_list',
  DictionaryCreate = 'dictionary_create',
  DictionaryRead = 'dictionary_read',
  DictionaryUpdate = 'dictionary_update',
  DictionaryDelete = 'dictionary_delete',
  DictionaryImport = 'dictionary-word_import',

  DictionaryWordList = 'dictionary-word_list',
  DictionaryWordCreate = 'dictionary-word_create',
  DictionaryWordRead = 'dictionary-word_read',
  DictionaryWordUpdate = 'dictionary-word_update',
  DictionaryWordDelete = 'dictionary-word_delete',

  LtiManage = 'lti_manage',
  LiaScriptManage = 'liascript_manage',
  InteractiveManage = 'interactive_manage',
  AdaptManage = 'adapt_manage',
  CourseBuilderUse = 'course_builder_use',
  LivingCourseReview = 'living_course_review',
}

export default PERMISSIONS;
